import { TelegramFeedPage } from "./-telegram-feed-page";
const SplitComponent = TelegramFeedPage;
export { SplitComponent as component };